export const ChevronIcon = () => {
  const size = 50;
  const points = [
    { x: -size, y: -size * 0.5 },
    { x: 0, y: -size * 0.5 },
    { x: size, y: 0 },
    { x: 0, y: size * 0.5 },
    { x: -size * 0.5, y: size * 0.5 },
    { x: -size, y: size * 0.25 },
    { x: -size * 0.5, y: 0 },
  ].map(p => `${p.x},${p.y}`).join(' ');

  return (
    <svg width="40" height="40" viewBox="-60 -60 120 120">
      <polygon points={points} fill="#fff" stroke="#333" strokeWidth="2" />
    </svg>
  );
};